<template>
    <div class="certificate__qr">
        <div class="certificate__qr-svg" v-html="svg"></div>
        <div v-if="showText" class="certificate__qr-text">{{ $t('certificate.validate_at') }} {{ host }}</div>
    </div>
</template>

<script>
import QRCode from 'qrcode';

/**
 * QR Code de validação no certificado do aluno (backlog#344): SVG em vetor
 * (imprime nítido em qualquer resolução), correção M, margem de silêncio.
 * O valor já vem com o código da emissão no endereço.
 */
export default {
    name: 'CertificateInputQrcode',

    props: { id: String, data: Object },

    data: () => ({ svg: '' }),

    computed: {
        url() { return this.data.value || (this.data.config && this.data.config.url) || ''; },
        showText() { return !!(this.data.config && this.data.config.showText); },
        host() { try { return new URL(this.url).host; } catch (e) { return window.location.host; } },
    },

    watch: { url() { this.render(); } },

    created() { this.render(); },

    methods: {
        async render() {
            try { this.svg = await QRCode.toString(this.url || ' ', { type: 'svg', errorCorrectionLevel: 'M', margin: 1 }); } catch (e) { this.svg = ''; }
        },
    },
};
</script>

<style scoped>
.certificate__qr { position: relative; width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; }
.certificate__qr-svg { width: 100%; aspect-ratio: 1 / 1; background: #fff; }
.certificate__qr-svg :deep(svg) { width: 100%; height: 100%; display: block; }
.certificate__qr-text { font-size: 9px; line-height: 13px; color: #333; white-space: nowrap; font-family: Roboto, sans-serif; }
</style>
